"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _EllipsisDropdown = _interopRequireDefault(require("../../../../../components/shared-components/EllipsisDropdown"));

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

var _axios = _interopRequireDefault(require("axios"));

var _ValidForm = _interopRequireDefault(require("./ValidForm"));

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

var _oldDetails = _interopRequireDefault(require("./oldDetails"));

var _reactCsv = require("react-csv");

var header = [{
  label: _RmName.default.nameCode,
  key: "RM_code"
}, {
  label: "Mother_name",
  key: "Mother_name"
}, {
  label: "Student_name",
  key: "Student_name"
}, {
  label: "Subject",
  key: "Subject"
}, {
  label: "WhatsApp_no",
  key: "WhatsApp_no"
}, {
  label: "DOB",
  key: "DOB"
}, {
  label: "Joining_date",
  key: "Joining_date"
}, {
  label: "school_type",
  key: "school_type"
}, {
  label: "School_fee",
  key: "School_fee"
}, {
  label: "Class",
  key: "Class"
}, {
  label: "Calling_no",
  key: "Calling_no"
}, {
  label: "English_label",
  key: "English_label"
}, {
  label: "English_worksheet_no",
  key: "English_worksheet_no"
}, {
  label: "Label",
  key: "Label"
}, {
  label: "Address",
  key: "Address"
}];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());

var TableData = function TableData(_ref) {
  var data = _ref.data;
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; //const [visible, setVisible]= useState(false);


  var _useState5 = (0, _react.useState)(data),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      enrolledRequests = _useState6[0],
      setenrolledRequests = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showData = _useState8[0],
      setshowData = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      allowView = _useState10[0],
      setAllow = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      request = _useState12[0],
      setRequset = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      allData = _useState14[0],
      setAllData = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      showOld = _useState16[0],
      setOld = _useState16[1];

  var _useState17 = (0, _react.useState)([]),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      showOldActionIndex = _useState18[0],
      setOldActionIndex = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      duplicateData = _useState20[0],
      setDuplicateData = _useState20[1];

  var _useState21 = (0, _react.useState)({}),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      duplicateMatch = _useState22[0],
      setDuplicateMatch = _useState22[1];

  var csvRport = {
    filename: "\"EnrollmentRequest Data\"+\" \"+".concat(today, "+\" \"+").concat(time),
    headers: header,
    data: data
  };
  var columns = [{
    title: _RmName.default.nameCode,
    dataIndex: "RM_code",
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Student Name",
    dataIndex: "Student_name",
    key: "Student_name",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Student_name');
    }
  }, {
    title: "Date",
    dataIndex: 'Joining_date',
    key: 'Joining_date',
    fixed: 'left',
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Joining_date');
    }
  }, {
    title: "Subject",
    dataIndex: "Subject",
    key: "Subject",
    fixed: 'left',
    render: function render(_, record) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Badge, {
        status: getSubjectsStatus(record.Subject)
      }), /*#__PURE__*/_react.default.createElement("span", null, record.Subject));
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Subject');
    }
  }, {
    title: 'Status',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        onClick: getStatusData(elm) === 'Old Number' ? function () {
          return showOldDetails(elm);
        } : ''
      }, /*#__PURE__*/_react.default.createElement(_antd.Tag, {
        color: getStatus(elm)
      }, getStatusData(elm)));
    }
  }, {
    title: "Calling No",
    dataIndex: "Calling_no",
    key: "Calling_no",
    fixed: 'left',
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Calling_no');
    }
  }, {
    title: 'Action',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm, index) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
        menu: getStatusData(elm) === 'Old Number' ? // eslint-disable-next-line
        showOldActionIndex.find(function (obj) {
          return obj === obj;
        }) || showOldActionIndex.find(function (i) {
          return i === index;
        }) === 0 ? dropdownMenu(elm) : '' : dropdownMenu(elm)
      }));
    }
  }];

  var getSubjectsStatus = function getSubjectsStatus(status) {
    if (status === 'Math') {
      return 'success';
    }

    if (status === 'English') {
      return 'warning';
    }

    if (status === 'Both') {
      return 'error';
    }

    return '';
  };

  var getStatus = function getStatus(elm) {
    var data1 = _utils.default.filterArray(allData, 'Calling_no', elm.Calling_no);

    var data2 = _utils.default.filterArray(allData, 'WhatsApp_no', elm.WhatsApp_no);

    if (data1.length > 0 || data2.length > 0) return 'error';else return 'success';
  };

  var getStatusData = function getStatusData(elm) {
    var data1 = _utils.default.filterArray(allData, 'Calling_no', elm.Calling_no);

    var data2 = _utils.default.filterArray(allData, 'WhatsApp_no', elm.WhatsApp_no);

    if (data1.length > 0 || data2.length > 0) return 'Old Number';else return 'New Number';
  };

  (0, _react.useEffect)(function () {
    function fatchData() {
      return _fatchData.apply(this, arguments);
    }

    function _fatchData() {
      _fatchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callParentDetails();
                setenrolledRequests(data);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fatchData.apply(this, arguments);
    }

    fatchData(); // eslint-disable-next-line
  }, [data]);

  function callParentDetails() {
    var url = _config.default.allParentDetailsAllCLs + cl;

    _axios.default.get(url, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      setAllData(resp.data);
      setLoading(false);
    }, function (err) {
      setapiError(err.response);
    });
  }

  var validInvalidRequest = function validInvalidRequest(elm, str) {
    setAllow(true);
    setshowData(elm);
    setRequset(str);
  };

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return validInvalidRequest(elm, 'Approved');
      },
      style: {
        color: 'green'
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.PlusCircleOutlined, {
      style: {
        color: 'green'
      },
      className: "mr-1"
    }), "Allow"))), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return validInvalidRequest(elm, 'Rejected');
      },
      style: {
        color: 'red'
      }
    }, "  ", /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      style: {
        color: 'red'
      },
      className: "mr-1"
    }), "Deny"))));
  };

  var showOldDetails = function showOldDetails(elm) {
    var arr = allData.filter(function (item) {
      return item.Calling_no === elm.Calling_no || item.WhatsApp_no === elm.WhatsApp_no;
    });
    setOld(true);
    setDuplicateData(arr);
    setDuplicateMatch(elm);
    var index = allData.map(function (e) {
      return e.Calling_no;
    }).indexOf(elm.Calling_no);
    var arr1 = showOldActionIndex;
    arr1.push(index);
    setOldActionIndex(arr1);
  };

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Enrollment Request",
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: enrolledRequests,
    rowKey: "index",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          record: record
        });
      }
    }
  })), allowView ? /*#__PURE__*/_react.default.createElement(_ValidForm.default, {
    visible: allowView,
    onOk: function onOk() {
      return setAllow(false);
    },
    onCancel: function onCancel() {
      return setAllow(false);
    },
    item: showData,
    request: request,
    width: 800
  }) : null, showOld ? /*#__PURE__*/_react.default.createElement(_oldDetails.default, {
    visible: showOld,
    onOk: function onOk() {
      return setOld(false);
    },
    onCancel: function onCancel() {
      return setOld(false);
    },
    item: duplicateData,
    duplicateMatch: duplicateMatch,
    width: 800
  }) : null);
};

var _default = TableData;
exports.default = _default;